var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaystack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10992",
    "data-name": "Group 10992",
    transform: "translate(-123 -398)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8656",
    "data-name": "Rectangle 8656",
    transform: "translate(123 398)",
    fill: "#fff",
    stroke: "rgba(112,112,112,0.25)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 4.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10016",
    "data-name": "Path 10016",
    d: "M-114.735,232.2h-15.5a.984.984,0,0,0-.964.983v1.755a.984.984,0,0,0,.964.983h15.5a1,1,0,0,0,.983-.983V233.2A.992.992,0,0,0-114.735,232.2Zm0,9.736h-15.5a.9.9,0,0,0-.675.289.947.947,0,0,0-.289.694v1.755a.984.984,0,0,0,.964.983h15.5a.987.987,0,0,0,.983-.983V242.92A.987.987,0,0,0-114.735,241.936ZM-121.5,246.8h-8.734a.9.9,0,0,0-.675.289,1.028,1.028,0,0,0-.289.694v1.755a.984.984,0,0,0,.964.983h8.715a.967.967,0,0,0,.964-.964V247.8A.927.927,0,0,0-121.5,246.8Zm7.751-9.736h-16.485a.9.9,0,0,0-.675.289,1.028,1.028,0,0,0-.289.694V239.8a.984.984,0,0,0,.964.983h16.465a.971.971,0,0,0,.964-.983v-1.754A.967.967,0,0,0-113.751,237.059Zm0,0",
    transform: "translate(265.88 177.642)",
    fill: "#00c3f7"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaystack);
export default __webpack_public_path__ + "static/media/paystack.6d8991101b3acbced0e9d16b0bf20213.svg";
export { ForwardRef as ReactComponent };